<!-- 我的账号 -->
<template>
    <div ref="scrollableDiv">
        <span style="color: white"> </span>
        <div class="container card">
            <h2 style="color: white">各平台账号关联</h2>
            <div class="tiptop">
                <el-tooltip class="box-item" effect="dark" content="Top Center prompts info" placement="top">
                    <template #content>
                        注意修改密码,必须先在【app】上进行修改,仅在系统上修改无效<br />账号状态为【不可用】时 ,将【无法下单】
                        <br />更新密码】会有一定【时间延迟】<br />【Ctrl+F】输入【手机号】进行【查找】
                    </template>
                    <el-icon>
                        <QuestionFilled />
                    </el-icon>
                </el-tooltip>
            </div>
            <hr style="margin-top: 25px; margin-bottom: 25px" />
            <div class="form-group">
                <el-select v-model="accountTypeId" placeholder="搜索平台" clearable style="width: 200px" @change="platformChange">
                    <div v-if="platformListresp.success">
                        <el-option v-for="platform in platformListresp.data" :key="platform.id" :label="platform.platformName" :value="platform.id"></el-option>
                    </div>
                </el-select>
                <el-button type="primary" style="margin-left: 15px" @click="addItem()">添加账号</el-button>
                <el-button type="" style="margin-left: 15px" @click="getTableList()">刷新</el-button>
            </div>
            <!-- 数据表格 -->
            <div class="eltable">
                <el-table :data="filterItems" :header-row-style="{ color: 'white' }" style="border-radius: 20px 20px 0 0" stripe>
                    <!-- 记录id -->
                    <!-- <el-table-column prop="id" v-if="testshow" label="id" header-align="center" align="center" width="80%">
                        <template v-slot="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->

                    <!-- 序号列 -->
                    <el-table-column label="序号" header-align="center" align="center" width="80%">
                        <template v-slot="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <!-- 是否可用 -->
                    <el-table-column header-align="center" align="center" label="状态">
                        <template v-slot="scope">
                            <el-button style="width: 80px" v-if="scope.row.accountStatus == 0" type="success">{{ scope.row.accountStatusStr }}</el-button>
                            <el-button style="width: 80px" v-if="scope.row.accountStatus == 1" type="info">{{ scope.row.accountStatusStr }}</el-button>
                        </template>
                    </el-table-column>
                    <!-- 平台名称 -->
                    <el-table-column label="平台" header-align="center" align="center">
                        <template v-slot="scope">
                            <span v-if="!scope.row.editable">{{ scope.row.accountTypeName }} </span>
                            <el-select v-else v-model="scope.row.tempPlatform" value-key="platformName">
                                <div v-if="platformListresp.success">
                                    <el-option v-for="platform in platformListresp.data" :key="platform.platformName" :label="platform.platformName" :value="platform"></el-option>
                                </div>
                            </el-select>
                        </template>
                    </el-table-column>
                    <!-- 账号 -->
                    <el-table-column prop="userAccount" label="账号" header-align="center" align="center">
                        <template v-slot="scope">
                            <span v-if="!scope.row.editable">{{ scope.row.userAccount }}</span>
                            <el-input v-else v-model="scope.row.tempName"></el-input>
                        </template>
                    </el-table-column>

                    <!-- 密码 -->
                    <el-table-column prop="password" label="密码" header-align="center" align="center">
                        <template v-slot="scope">
                            <span v-if="!scope.row.editable">{{ scope.row.password }}</span>
                            <el-input v-else v-model="scope.row.tempPwd"></el-input>
                        </template>
                    </el-table-column>

                    <!-- 操作列 -->
                    <el-table-column label="操作" header-align="center" align="center">
                        <template v-slot="scope">
                            <el-button type="primary" @click="handleEdit(scope.row)" v-if="!scope.row.editable"> 编辑 </el-button>
                            <el-button type="default" @click="handleCancel(scope.row)" v-if="scope.row.editable"> 取消 </el-button>
                            <el-button type="success" @click="handleSave(scope.row)" v-if="scope.row.editable"> 保存 </el-button>
                            <el-button type="danger" @click="handleDelete(scope.row)" v-if="scope.row.editable"> 删除 </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="addone">
                    <el-button type="primary" style="margin-right: 15px" @click="addItem()">添加</el-button>
                </div>
                <el-pagination
                    v-model:currentPage="currentPage"
                    v-model:page-size="itemsPerPage"
                    :page-sizes="[20, 40, 60, 80]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="allpages"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="display: flex; justify-content: center; margin-top: 20px" />
            </div>
        </div>
        <FixedButtons @scroll-to-top="scrollToTop" />
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";
    import swal from "sweetalert2";

    export default {
        name: "PracticalTableView",
        components: { FixedButtons },
        data() {
            return {
                // 单行编辑
                canedit: true,
                // 新增
                caninsert: true,

                testshow: process.env.VUE_APP_SHOW === "true",
                // 下拉框初始化
                platformURL: "/api/systemPlatformInfo/platForm/init",
                accountURL: "/api/externalAccount/queryExternalAccount",
                insertURL: "/api/externalAccount/insertCurrentUserExternalAccount",
                deleteURL: "/api/externalAccount/deletedCurrentUserExternalAccount",
                updateURL: "/api/externalAccount/update",

                platformListresp: { data: [] },

                aa: "",

                // el 表格
                tableData: [],
                tempPlatform: { name: "", id: "" },
                search: "",

                scrollableDiv: null,
                currentPage: 1, // 当前页码
                itemsPerPage: 20, // 每页显示条目数
                allpages: 1, // 总页数
                accountTypeId: "", //平台ID
            };
        },

        // 进入页面时就获取数据
        // beforeRouteEnter(to, from, next) {
        //     next((vm) => {
        //         vm.getplatformListresp();
        //     });
        // },
        methods: {
            getTableList() {
                this.scrollableDiv = this.$refs.scrollableDiv;
                axios
                    .get(this.accountURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            accountTypeId: this.accountTypeId,
                        },
                    })
                    .then((response) => {
                        this.getplatformListresp();
                        this.allpages = response.data.data.total;
                        this.tableData = response.data.data.result; // 将获取的数据赋值给tableData
                        this.aa = response.data.data; // 将获取的数据赋值给tableData
                    })
                    .catch((error) => {
                        console.error("Error fetching data", error);
                    });
            },
            // 表格添加
            addItem() {
                this.scrollToBottom();

                // 将新数据对象添加到 filterItems 数组中

                if (this.canedit && this.caninsert) {
                    this.caninsert = false;
                    this.search = "";
                    this.tableData.push({ platformId: "", accountTypeName: "占位符", tempPlatform: { platformName: "", id: "" } });
                    if (Array.isArray(this.tableData) && this.tableData.length > 0) {
                        const lastItem = this.tableData[this.tableData.length - 1];

                        if (typeof this.handleEdit === "function") {
                            this.handleEdit(lastItem);
                        } else {
                            return;
                        }
                    } else {
                        return;
                    }
                } else {
                    // todo 提示先保存数据
                    return;
                }
            },

            // 平台下拉框初始化
            getplatformListresp() {
                axios
                    .get(this.platformURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((response) => {
                        this.platformListresp = response.data;
                    })
                    .catch((error) => {
                        console.error("请求出错：", error);
                    });
            },
            // 退出编辑
            outedit() {
                this.canedit = true;
                this.caninsert = true;
            },
            // 表格编辑
            handleEdit(row) {
                if (this.canedit) {
                    this.canedit = false;
                } else {
                    // todo 弹窗提示
                    return;
                }
                // 进入编辑状态
                row.editable = true;
                // 保存原始数据到临时变量，用于编辑
                if (row.tempPlatform) {
                    // pass
                } else {
                    row.tempPlatform = { platformName: "", id: "" };
                }
                row.tempId = row.id;
                row.tempPlatform.platformName = row.accountTypeName;
                row.tempName = row.userAccount;
                row.tempPwd = row.password;
                row.tempStatus = row.accountStatusStr;
            },
            // 保存/更新
            handleSave(row) {
                // 保存编辑
                row.editable = false;
                // 更新原始数据
                row.userAccount = row.tempName;
                row.password = row.tempPwd;
                row.accountTypeName = row.tempPlatform.platformName;
                row.platformId = this.findItemId(row.accountTypeName);
                if (row.platformId === null || row.platformId === "" || typeof row.platformId === "undefined") {
                    swal.fire("操作失败", "填写的信息不完整", "error");
                    this.outedit();
                    return;
                } else {
                    //
                }
                swal.fire({
                    title: "确认修改",
                    text: "你确定要修改/添加信息吗？",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }).then((result) => {
                    if (result.isConfirmed) {
                        // 用户点击了确认按钮，执行更新操作
                        this.saveRow(row);
                    }
                    this.outedit();
                });
            },
            saveRow(row) {
                if (row.id !== null && typeof row.id !== "undefined") {
                    // 调用 更新接口
                    const body = [{ userAccount: row.userAccount, password: row.password, accountTypeId: row.platformId, id: row.id }];
                    // todo 先判断 所填信息先填完整
                    axios
                        .post(this.updateURL, body, {
                            headers: {
                                satoken: localStorage.sa,
                                "Content-Type": "application/json",
                            },
                        })
                        .then((response) => {
                            // todo 处理成功响应
                            if (response.data.code === 200) {
                                swal.fire({
                                    title: "操作成功!",
                                    text: response.data.data,
                                    icon: "success",
                                    confirmButtonText: "确定",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        window.location.reload();
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: "绑定失败!",
                                    text: response.data.data,
                                    icon: "error",
                                    confirmButtonText: "取消",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        window.location.reload();
                                    }
                                });
                            }
                        })
                        .catch((error) => {
                            // 处理错误
                            console.error("新增失败", error);
                        });
                } else {
                    // 调用 新增接口

                    const body = [{ userAccount: row.userAccount, password: row.password, accountTypeId: row.platformId }];
                    // todo 先判断 所填信息先填完整
                    axios
                        .post(this.insertURL, body, {
                            headers: {
                                satoken: localStorage.sa,
                                "Content-Type": "application/json",
                            },
                        })
                        .then((response) => {
                            if (response.data.code === 200) {
                                swal.fire({
                                    title: "操作成功!",
                                    text: response.data.data,
                                    icon: "success",
                                    confirmButtonText: "确定",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        window.location.reload();
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: "绑定失败!",
                                    text: response.data.data,
                                    icon: "error",
                                    confirmButtonText: "取消",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        window.location.reload();
                                    }
                                });
                            }
                        })
                        .catch((error) => {
                            // 处理错误
                            console.error("新增失败", error);
                        });
                }
                this.outedit();
            },

            // 取消编辑
            handleCancel(row) {
                // 取消编辑
                row.editable = false;
                // 恢复临时变量数据到原始数据
                row.tempName = "";
                row.tempPwd = 0; // 或者任何其他你希望的默认值
                if (typeof row.id === "undefined" || row.id === null) {
                    const index = this.tableData.indexOf(row);
                    this.tableData.splice(index, 1);
                }
                this.outedit();
            },

            // 删除数据
            handleDelete(row) {
                // todo 提示弹窗确认删除
                // 取消编辑
                row.editable = false;
                swal.fire({
                    title: "确认删除",
                    text: "你确定要删除这条记录吗？",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }).then((result) => {
                    if (result.isConfirmed) {
                        // 用户点击了确认按钮，执行删除操作
                        this.deleteRow(row);
                    }
                    this.outedit();
                });
            },

            findItemId(nameValue, itemsDict = this.platformListresp.data) {
                // 使用参数 nameValue 作为要查找的平台名称
                let platform = itemsDict.find((item) => item.platformName === nameValue);

                if (platform) {
                    // 如果找到匹配的平台名称，platform 是包含 id 和 platformName 的对象
                    let id = platform.id;
                    // 返回找到的 id
                    return id;
                } else {
                    // 如果没有找到匹配的平台名称，可以返回一个默认值或者做其他处理
                    return null; // 或者其他默认值
                }
            },
            // 删除数据实现
            deleteRow(row) {
                // 恢复临时变量数据到原始数据
                row.tempName = "";
                row.tempPwd = 0; // 或者任何其他你希望的默认值
                row.tempPlatformName = "";
                row.tempPlatform = { platformName: "", id: "" };
                if (typeof row.id !== "undefined" && row.id !== null) {
                    // 123
                    const body = [{ id: row.id }];
                    axios
                        .delete(this.deleteURL, {
                            headers: {
                                satoken: localStorage.sa,
                                "Content-Type": "application/json",
                            },
                            data: body,
                        })
                        .then((response) => {
                            // todo 处理成功响应
                            swal.fire({
                                title: "成功",
                                text: response.data.data,
                                icon: "success",
                                confirmButtonText: "确定",
                            });
                            //todo 刷新表格
                        })
                        .catch((error) => {
                            // 处理错误
                            console.error("删除失败", error);
                        });
                }
                const index = this.tableData.indexOf(row);
                if (index !== -1) {
                    this.tableData.splice(index, 1);
                }
                this.outedit();
            },

            // 页面顶部
            scrollToTop() {
                this.scrollableDiv.scrollTo({
                    top: 0,
                    behavior: "auto",
                });
            },

            // 页面底部
            scrollToBottom() {
                this.scrollableDiv.scrollTo({
                    top: this.scrollableDiv.scrollHeight,
                    behavior: "auto",
                });
            },
            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.getTableList();
            },
            //改变页数
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getTableList();
            },
            platformChange() {
                this.getTableList();
            },
        },
        computed: {
            filterItems() {
                return this.tableData.filter((item) => {
                    return item.accountTypeName && item.accountTypeName.match(this.search);
                });
            },
        },
        mounted() {},
    };
</script>

<style lang="scss" scoped>
    /* 表格样式*/
    .el-table {
        justify-content: center;
        --el-table-header-bg-color: rgb(107, 107, 107);
        --el-table-text-color: #000000;
        --el-table-border: 1px solid #ebeef5;
    }

    .addone {
        width: 100%;
        justify-content: center;
        display: flex;
        background-color: aliceblue;
        border-radius: 0 0 20px 20px;
    }

    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;
        }
    }

    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
    }

    .card {
        background-color: transparent;
        border: 1px solid transparent;
    }

    .form-control {
        background-color: #ded9d9;
        margin: 0;
    }

    .thead-dark {
        background-color: #585d6b;
        color: white;
    }

    .form-group {
        margin-bottom: 25px;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -53px;
        left: 215px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }
</style>
